import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import * as videosClient from 'ContentData/api/Videos';
import { VIDEOS_FETCH_VIDEO_2, VIDEOS_SAVE_VIDEO } from 'ContentData/actions/ActionTypes';
const fetchVideo2Action = createGenericFetchAction(VIDEOS_FETCH_VIDEO_2, videosClient.fetchVideo2);
export const fetchVideoByPlayerId = fetchVideo2Action;
export const saveVideo = (playerId, video) => ({
  type: VIDEOS_SAVE_VIDEO,
  video,
  playerId
});